import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Placeholder } from 'components/placeholder'
import React, { Suspense } from 'react'
import './styles.scss'

interface IProps {
  storiesList: number[]
}

interface IState {
  storiesList: Story[]
}

interface Story {
  image: string
  title: string
  lead: string
  id: number
}

export class RelatedStories extends React.Component<IProps, IState> {
  public constructor(props: any) {
    super(props)
    this.state = { storiesList: [] }
  }

  public componentDidMount(): void {
    const domain = parseHostname()

    for (let story in this.props.storiesList) {
      let storyId = this.props.storiesList[story]

      window
        .fetch(`https://m.${domain.publicationDomain}/api/articles/${storyId}`)
        .then(response => {
          if (response.ok) {
            return response.json()
          }
          throw new Error(`${response.status}: ${response.statusText}`)
        })
        .then(data => {
          let story = {
            image: data.article.picture_teaser_fresh_url,
            title: data.article.title,
            lead: data.article.lead,
            id: storyId
          }
          let storiesList = [...this.state.storiesList]
          storiesList.push(story)
          this.setState({ storiesList: storiesList })
        })
        .catch(e => {
          // tslint:disable-next-line
          console.groupCollapsed('Main')
          // tslint:disable-next-line
          console.warn('API Access failed: ', e)
          // tslint:disable-next-line
          console.groupEnd()
        })
    }
  }

  public render() {
    return (
      <div className='related-stories'>
        <Suspense fallback={<Placeholder />}>
          <div className='ui text container'>
            <h3 className='ui small infographic header'>
              Poursuivez votre lecture
            </h3>
          </div>
          <div className='ui stackable grid three columns row'>
            {this.state.storiesList.map((story: Story, id: number) => {
              return (
                <a
                  key={id}
                  href={
                    'https://' +
                    parseHostname().publicationDomain +
                    '/' +
                    story.id
                  }
                  className='column'
                >
                  <img src={story.image} />
                  <div
                    className='story-title'
                    dangerouslySetInnerHTML={{ __html: story.title }}
                  />
                  <p dangerouslySetInnerHTML={{ __html: story.lead }} />
                  <p className='pseudo-link'>Lire la suite</p>
                </a>
              )
            })}
          </div>
        </Suspense>
      </div>
    )
  }
}
